import React from "react";

import FleetConfiguration from "modules/FleetConfiguration";

const FLEET_PARAMETERS = [];

const CmFleetConfigurationComponent = () => {
    return <FleetConfiguration parameters={FLEET_PARAMETERS} />;
};

export default CmFleetConfigurationComponent;
